import { Component, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwMetaDataListCardConfigData } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames } from '../../../../../meta-data/app-meta-data.service';


@DwComponent<DwMetaDataListCardConfigData>({
  name: 'No Assignments Card',
  key: 'noAssignmentsCard',
  componentType: DwComponentType.card,
  //configComponent: DwCardDefaultConfigComponent,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.Assignment,
  configData: {
  }
})
@Component({
  selector: 'app-assignment-blank-card',
  templateUrl: './assignment-blank-card.component.html',
  styleUrls: ['./assignment-blank-card.component.scss']
})
export class AssignmentBlankCardComponent implements OnInit {

  assignmemtImageUrl = '/assets/aviator-online/img/no-assignments-card.png';
  constructor() { }

  ngOnInit(): void {
  }

}
